export default {
    apiKey: "AIzaSyAnv8n-CITfY5ZEOgpvKxgHN6BbY_Yn1WE",
    authDomain: "simfic2ground.firebaseapp.com",
    databaseURL: "https://simfic2ground.firebaseio.com",
    projectId: "simfic2ground",
    storageBucket: "simfic2ground.appspot.com",
    messagingSenderId: "632645769564",
    appId: "1:632645769564:web:f6ccad4a2e0b17d867c999",
    measurementId: "G-8FF8NK14J8"
  }